import requests from "./httpService";


const VendorRatesServices = {
  getAllVendorRates: async () => {
    return requests.get(`vendortariff/vendor-sheet-rates`);
  },

  createVendorRatesLink:async(body)=>{
    return requests.post(`vendortariff/vendor-rate-links`,body)
  }
}

export default VendorRatesServices